import React,{useState,useEffect} from 'react'
import articleService from "../../../services/articles.service"
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";

function ArticlesDashboard() {
  const [articles,setArticles] = useState([])
  const navigate = useNavigate()
  const [rowModesModel, setRowModesModel] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
  });
  const [rowCount, setRowCount] = useState(10);
  const columns = [
    { field:"id",headerName:"ID"},
    {field:"title",headerName:"Title",width:"200"},
    {field:"status",headerName:"Status",
      valueGetter:(params)=>{
        if(params.value === 1){
          return "Active"
        }
        return "Inactive"
      }
  },
    {field:"category",headerName:"Category",width:"250"},
    {
        field:"actions",
        type:"actions",
        headerName:"Actions",
        getActions:({id})=>{
            return [
                <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => handleEditClick(id)}
            color="inherit"
          />
            ]
        }
    }
  ];
  useEffect(()=>{
    getArticles(paginationModel.page,paginationModel.pageSize);
  },[paginationModel.page,paginationModel.pageSize])

  const handleEditClick = (id)=>{
    console.log("Edit Clicked : "+id)
    navigate('/articles/'+id);

  }

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const getArticles = (page,size)=>{
   articleService.getArticles(page,size)
   .then(res=>{
        setArticles(res.data.content)
        setRowCount(res.data.totalElements)
   })
   .catch(err=>{
    console.log(err)
   })
  }

  return (
    <div className="card">
        <div className="card-body p-2">
        <DataGrid
            rows={articles}
            rowCount={rowCount}
            columns={columns}
            pagination
          paginationModel={paginationModel}
          pageSizeOptions={[5, 10, 15]}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
        </div>
    </div>
   
  )
}

export default ArticlesDashboard